
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Les produits distribués en Suisse font l'objet d'un
`}<a parentName="p" {...{
        "href": "291128389286"
      }}>{`suivi rapproché`}</a>{` et d’éventuels effets secondaires doivent être
signalés.`}</p>
    <p>{`De manière générale,
`}<a parentName="p" {...{
        "href": "https://ofsp-coronavirus.ch/vaccination/effets-secondaires-et-questions/"
      }}>{`les vaccins à ARN messager injectés dans notre pays provoquent surtout`}</a>{`
des réactions au site d’injection (notamment des rougeurs), des douleurs
musculaires ou articulaires, des frissons, des maux de tête, de la fièvre…`}</p>
    <p>{`Ces effets secondaires, qui sont plus fréquents après la deuxième dose, sont
classiques après un vaccin, quel qu’il soit. Alessandro Diana, expert chez
Infovac, les qualifie de "bas grade", soit pas dangereux. Mais
`}<a parentName="p" {...{
        "href": "955444364599"
      }}>{`il a été surpris par leur fréquence`}</a>{`.`}</p>
    <p>{`Selon Blaise Genton, responsable médical de la campagne vaudoise de vaccination,
la fièvre touche environ une personne sur dix après la première dose et une à
deux sur dix après la deuxième. Environ la moitié des individus sont fatigués ou
patraques et la majorité ont une douleur au point d’injection. "Il semble que
ces situations sont un peu plus fréquentes avec le vaccin de Moderna (que celui
de Pfizer, ndlr), mais la différence est vraiment faible."`}</p>
    <p>{`Une consolation pour ceux qui sont au lit: "Si ces produits sont relativement
réactogènes, ils figurent parmi les plus efficaces", assure Blaise Genton. Les
deux choses vont de pair. Alessandro Diana compare la vaccination à un
entraînement, dans lequel le système immunitaire apprend à résister à un virus.
"Dans le cas du Covid, cela ressemble plus à une instruction militaire qu’à un
tour de présentation du fitness." Forcément, l’exercice est bon, mais il peut
malmener. Il faut préciser que ce principe vaut à un niveau "global" et non
individuel: si vous n'avez pas réagi, cela ne signifie pas que le vaccin n'a pas
fonctionné chez vous.`}</p>
    <p>{`Un phénomène est spécifique à cette vaccination, c’est le «bras Covid». Il
s’agit de rougeurs et gonflements parfois importants sur le bras dans lequel le
produit a été injecté. Ce phénomène a surtout été constaté avec le produit de
Moderna et concernerait environ 8 personnes sur 1000 après la première dose et 2
sur 1000 après la deuxième. Il apparaît en général après une semaine environ et
disparaît en quelques jours. Ce n’est pas dangereux mais désagréable. Là encore,
ce serait la preuve que l’immunité a bien marché.`}</p>
    <p>{`Parmi les réactions, on peut encore mentionner une détresse respiratoire, la
réactivation de zonas, des nausées ou des vomissements. Swissmedic indique que,
dans la plupart des cas, la santé des sujets n'a pas été mise en danger. Un
effet secondaire grave est le
`}<a parentName="p" {...{
        "href": "https://www.infovac.ch/docs/public/coronavirus/ssai-recommandations-pour-vaccins-contre-covid-19-en-cas-d-allergies-v8-2-f.pdf"
      }}>{`choc anaphylactique`}</a>{`
qui se produit chez certaines personnes dans les minutes suivant l'injection.
Ces accidents, qui ne concernent pas plus d'un individu sur 300'000, peuvent
être stoppés avec une injection d'adrénaline.`}</p>
    <p>{`Début octobre 2021, la Suède et la Finlande ont suspendu par mesure de
précaution l'utilisation de ce vaccin pour les moins de 30 ans. Ces décisions
ont été prises «après des signes de risque accru d’effets secondaires comme les
`}<a parentName="p" {...{
        "href": "517110665150"
      }}>{`inflammations du myocarde et du péricarde`}</a>{` (ndlr: l’enveloppe du
myocarde)». L’agence suédoise de santé publique a précisé que ce danger est
minime et que la maladie disparaît souvent d’elle-même sans causer de problème.
Le Danemark et la Norvège ont déconseillé cette injection aux moins de 18 ans.`}</p>
    <p>{`La décision de la Suède a surpris Alessandro Diana, pédiatre à la clinique
genevoise des Grangettes et expert chez Infovac. Il précise que la myocardite
vaccinale concerne surtout les jeunes hommes de moins de 30 ans, après
l'injection de la deuxième dose. «Pour eux, et selon les données de
pharmacovigilance, ce risque est de 6 pour 100’000. Dans le groupe de contrôle,
cette incidence est de 1 à 2 cas pour 100’000.» Il souligne toutefois que ces
mêmes jeunes hommes ont six fois plus de risques de développer une telle
inflammation du coeur s'ils sont exposés au variant Delta.`}</p>
    <p>{`Swissmedic a pour sa part indiqué qu'elle n'avait pas pour l'heure l'intention
d'adapter son autorisation. Au 21 septembre 2021, l'autorité de surveillance
avait évalué
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/covid-19-vaccines-safety-update-5.html"
      }}>{`151 signalements de suspicion de myocardite ou de péricardite`}</a>{`
ayant une relation temporelle avec la vaccination. Vingt-six ont été observés en
lien avec le vaccin de Pfizer et 124 avec celui de Moderna. Dans un cas, le
vaccin est inconnu.`}</p>
    <p>{`Le 15 octobre 2021,
`}<a parentName="p" {...{
        "href": "195265998917"
      }}>{`le canton de Vaud a pris une décision en décalage avec cette position officielle`}</a>{`.
Comme "Le Courrier" l'a révélé, il a recommandé de vacciner les 12-18 ans avec
Pfizer plutôt qu'avec Moderna. Ce canton est le seul à avoir fait un tel choix,
par mesure de précaution.`}</p>
    <p>{`Interrogé par l'agence de presse ATS, Blaise Genton souligne que "l'incidence
(des myocardites et des péricardites, ndlr) n'est que très légèrement
supérieure" pour le vaccin de Moderna que pour celui de Pfizer. "La différence
est donc très faible et les données des études pas forcément toujours très
solides", insiste-t-il. Avant de conclure que puisque l'alternative Pfizer
existe, "nous proposons de prioriser ce vaccin pour les jeunes de moins de 18
ans."`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;